import axios from 'axios'
import _get from 'lodash/get'

export const PENSIONS_CONTRIBUTIONS_GET = 'PENSIONS_CONTRIBUTIONS_GET'
export const PENSIONS_CONTRIBUTIONS_UPDATE = 'PENSIONS_CONTRIBUTIONS_UPDATE'
export const PENSIONS_CONTRIBUTIONS_SAVE = 'PENSIONS_CONTRIBUTIONS_SAVE'
export const PENSIONS_CONTRIBUTIONS_SAVING = 'PENSIONS_CONTRIBUTIONS_SAVING'
export const PENSIONS_CONTRIBUTIONS_SAVE_SUCCESS = 'PENSIONS_CONTRIBUTIONS_SAVE_SUCCESS'
export const PENSIONS_CONTRIBUTIONS_SAVE_ERROR = 'PENSIONS_CONTRIBUTIONS_SAVE_ERROR'

export const getPensionsContributions = (selfAssessmentId) => (dispatch) => {
    axios
        .get(`/pensionscontributions/${selfAssessmentId}`)
        .then((response) => {
            const pensionsContributions = { ...response.data, shouldFetch: false, fetchSuccessful: true }

            dispatch(updatePensionsContributions(pensionsContributions))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(updatePensionsContributions({ shouldFetch: false, fetchSuccessful: true }))
            }
        })
}

export const updatePensionsContributions = (pensionsContributions) => ({
    type: PENSIONS_CONTRIBUTIONS_UPDATE,
    pensionsContributions,
})

export const savePensionsContributions = () => (dispatch, getState) => {
    const { assessment, pensionsContributions } = getState()

    dispatch(pensionsContributionsSaving, pensionsContributions)

    axios
        .put(`/pensionscontributions/${assessment.id}`, {
            ...pensionsContributions,
            selfAssessmentId: assessment.id,
        })
        .then((response) => {
            const data = { ...response.data, isAllowanceUpdate: pensionsContributions.isAllowanceUpdate }

            dispatch(pensionsContributionsSaveSuccess(data))
        })
        .catch((error) => {
            dispatch(pensionsContributionsSaveError(pensionsContributions, _get(error, ['response', 'data'])))
        })
}

export const updateAndSavePensionsContributions = (pensionsContributions) => (dispatch) => {
    dispatch(updatePensionsContributions(pensionsContributions))
    dispatch(savePensionsContributions())
}

export const pensionsContributionsSaving = (pensionsContributions) => ({
    type: PENSIONS_CONTRIBUTIONS_SAVING,
    pensionsContributions,
})

export const pensionsContributionsSaveSuccess = (pensionsContributions) => ({
    type: PENSIONS_CONTRIBUTIONS_SAVE_SUCCESS,
    pensionsContributions,
})

export const pensionsContributionsSaveError = (pensionsContributions, errorResponse) => ({
    type: PENSIONS_CONTRIBUTIONS_SAVE_ERROR,
    pensionsContributions,
    errorResponse,
})
